var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { getThemePref, getResolvedTheme, setThemePref, onThemeChange } from '../theme';
import { t } from '../i18n';
import { LocaleController } from '../i18n/LocaleController';
import './vitesse-dropdown';
/*
 * <vitesse-theme-toggle> — auto/light/dark picker. A THIN wrapper over the shared
 * <vitesse-dropdown>: it owns only the theme state + the sun/moon trigger icon;
 * the dropdown owns the panel, open/close, and a11y. (Was a hand-rolled panel;
 * now there's one dropdown for theme + language + chart theme.)
 */
let ThemeToggle = class ThemeToggle extends LitElement {
    constructor() {
        super();
        this.pref = getThemePref();
        this.resolved = getResolvedTheme();
        new LocaleController(this); // re-label Theme/Auto/Light/Dark on language change
    }
    connectedCallback() {
        super.connectedCallback();
        this.unsub = onThemeChange((r) => (this.resolved = r));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.unsub?.();
    }
    pick(value) {
        setThemePref(value);
        this.pref = value;
    }
    render() {
        const items = [
            { value: 'auto', label: t('theme.auto'), icon: 'monitor' },
            { value: 'light', label: t('theme.light'), icon: 'sun' },
            { value: 'dark', label: t('theme.dark'), icon: 'moon' },
        ];
        return html `<vitesse-dropdown
      .triggerIcon=${this.resolved === 'dark' ? 'sun' : 'moon'}
      .triggerTitle=${t('header.theme')}
      .items=${items}
      .value=${this.pref}
      @dropdown-select=${(e) => this.pick(e.detail.value)}
    ></vitesse-dropdown>`;
    }
};
__decorate([
    state()
], ThemeToggle.prototype, "pref", void 0);
__decorate([
    state()
], ThemeToggle.prototype, "resolved", void 0);
ThemeToggle = __decorate([
    customElement('vitesse-theme-toggle')
], ThemeToggle);
export { ThemeToggle };
//# sourceMappingURL=theme-toggle.js.map